// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ap2YBC {
  position: absolute !important;
  z-index: 4000;
  min-width: 0 !important;
  width: 368px !important;
  max-width: 100% !important;
  top: var(--spacing-2);
  right: var(--spacing-2);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/layouts/DrawerOperator/DrawerOperator.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;AACzB","sourcesContent":[".toastInDrawer {\n  position: absolute !important;\n  z-index: 4000;\n  min-width: 0 !important;\n  width: 368px !important;\n  max-width: 100% !important;\n  top: var(--spacing-2);\n  right: var(--spacing-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toastInDrawer": `Ap2YBC`
};
module.exports = ___CSS_LOADER_EXPORT___;
